import _objectWithoutProperties from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/objectWithoutProperties.js";
import _classCallCheck from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js";
import _createClass from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import _typeof from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/typeof.js";
var _excluded = ["useAtta", "url"];
var _globalObject$locatio, _globalObject$locatio2;
/*
 *@author   tonicli
 *@date     2016/9/16
 */
import { globalObject } from "./system";
import { buildUrl } from "./url";
var protocol = /^(http|https):$/.test((_globalObject$locatio = globalObject.location) === null || _globalObject$locatio === void 0 ? void 0 : _globalObject$locatio.protocol) ? (_globalObject$locatio2 = globalObject.location) === null || _globalObject$locatio2 === void 0 ? void 0 : _globalObject$locatio2.protocol : 'https:';
var bossUrl = "".concat(protocol, "//btrace.qq.com/kvcollect");
var boss2attaUrl = "".concat(protocol, "//h.trace.qq.com/bosskv");
var attaUrl = "".concat(protocol, "//h.trace.qq.com/kv");
var bossIdPattern = /^[1-9]\d{2,5}$/;
var boss2attaIdPattern = /^(z|Z)/;
function _handle() {}
function _isObject(value) {
  var type = _typeof(value);
  return !!value && (type === 'object' || type === 'function');
}
function _mapValues(obj, iter) {
  if (!_isObject(obj)) {
    return obj;
  }
  var retObj = {};
  Object.keys(obj).forEach(function (p) {
    retObj[p] = iter(obj[p]);
  });
  return retObj;
}
function _encodeDollor2(content) {
  var useAtta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (typeof content !== 'string') {
    return content;
  }
  var replacement = useAtta ? '\\$' : '|||';
  return content.replace(/\$/g, replacement);
}
var Boss = /*#__PURE__*/function () {
  /**
   *
   * @param {Object} cfg - {bossId: xxx, pwd: xxx}或者{attaId: xxx, token: xxx}
   * @param {string|number} [cfg.bossId] - boss系统分配的bossid
   * @param {string|number} [cfg.pwd] - boss系统分配的pwd
   * @param {string|number} [cfg.attaId] - atta系统分配的AttaID
   * @param {string|number} [cfg.token] - atta系统分配的Token
   * @param {boolean} [cfg.useAtta] - 是否强制走atta上报
   */
  function Boss(cfg) {
    _classCallCheck(this, Boss);
    if (!cfg || (!cfg.bossId || !cfg.pwd && parseInt(cfg.pwd, 10) !== 0) && (!cfg.attaId || !cfg.token)) {
      throw new Error('[vft-common.Boss]config中缺少{bossId, pwd}或者{attaId, token}');
    }
    this._cfg = cfg;
    var _this$normalizeConfig = this.normalizeConfig(cfg),
      useAtta = _this$normalizeConfig.useAtta,
      url = _this$normalizeConfig.url,
      params = _objectWithoutProperties(_this$normalizeConfig, _excluded);
    this.useAtta = useAtta;
    this._baseUrl = buildUrl(cfg.baseUrl || url, params);
  }
  _createClass(Boss, [{
    key: "normalizeConfig",
    value: function normalizeConfig(config) {
      var useAtta = config.useAtta,
        bossId = config.bossId,
        pwd = config.pwd,
        attaId = config.attaId,
        token = config.token;
      if (!useAtta && bossIdPattern.test(bossId)) {
        return {
          useAtta: false,
          url: bossUrl,
          BossId: bossId,
          Pwd: pwd
        };
      }
      var params = {
        useAtta: true,
        attaid: attaId || bossId,
        token: token || pwd
      };
      params.url = boss2attaIdPattern.test(params.attaid) ? boss2attaUrl : attaUrl;
      return params;
    }
  }, {
    key: "report",
    value: function report(params) {
      this._doReport(this.buildReportUrl(params));
      return this;
    }
  }, {
    key: "buildReportUrl",
    value: function buildReportUrl(params) {
      var _this = this;
      var url = buildUrl(this._baseUrl, _mapValues(params, function (v) {
        if (_isObject(v)) {
          try {
            v = JSON.stringify(v);
          } catch (e) {}
        }
        return _encodeDollor2(v, _this.useAtta);
      }), true);
      return _encodeDollor2(url, this.useAtta);
    }
  }, {
    key: "setBaseUrl",
    value: function setBaseUrl(url) {
      this._baseUrl = url;
      return this;
    }
  }, {
    key: "getBaseUrl",
    value: function getBaseUrl() {
      return this._baseUrl;
    }
  }, {
    key: "_doReport",
    value: function _doReport(url) {
      // 临时处理，非浏览器环境不上报
      if (!globalObject.document) return this;
      var reportObject = document.createElement('img');
      reportObject.onerror = _handle;
      reportObject.onload = _handle;
      reportObject.onabort = _handle;
      reportObject.src = url;
      return this;
    }
  }, {
    key: "_encodeDollor",
    value: function _encodeDollor(content, useAtta) {
      return _encodeDollor2(content, useAtta);
    }
  }]);
  return Boss;
}();
export { Boss as default };